import React from "react"
import { Col, Row } from "react-bootstrap"

import FontAwesome from "react-fontawesome"

import CustomerInfoTable from "./CustomerInfoTable"
import CustomerDocumentTable from "./CustomerDocumentTable"
import { blockingFetchService } from "../../../lib/blockingFetch"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import '../index.css'

class CustomerDataSettings extends React.Component {

  state = {
    customerInfos: [],
    customerDocuments: [],
    showCustomerInfo: true,
    showCustomerDocuments: true,
    runningInfo: false,
    runningDocuments: false,
    successInfo: false,
    successDocuments: false,
    error: null,
    errorInfo: null,
    errorDocuments: null,
  }

  componentDidMount() {
    this.loadData()
  }

  loadData = () => {

    this.setState({ error: null })

    blockingFetchService(
      accessToken => apiServerApi.getCustomerConfig(accessToken), 
      response => {
        const { customerFields, documentFields } = response
        this.setState({
          customerInfos: customerFields ? customerFields : [],
          customerDocuments: documentFields ? documentFields : []
        })
      },
      error => this.setState({ error: error.text }),
      _ => {}
    )
  }

  saveCustomerInfo = data => {

    this.setState({
      runningInfo: true,
      successInfo: false,
      errorInfo: null,
    })
  
    blockingFetchService(
      accessToken => apiServerApi.saveCustomerInfo(accessToken, data), 
      _ => {
        this.setState({ successInfo: true })
        setTimeout(() => this.setState({ successInfo: false }), 5000)
      },
      error => this.setState({ errorInfo: error.text }),
      _ => this.setState({ runningInfo: false })
    )
  }

  saveCustomerDocuments = data => {

    this.setState({
      runningDocuments: true,
      successDocuments: false,
      errorDocuments: null,
    })

    blockingFetchService(
      accessToken => apiServerApi.saveCustomerDocuments(accessToken, data), 
      _ => {
        this.setState({ successDocuments: true })
        setTimeout(() => this.setState({ successDocuments: false }), 5000)
      },
      error => this.setState({ errorDocuments: error.text }),
      _ => this.setState({ runningDocuments: false })
    )
  }

  infoExists = (name, customerInfos) =>
    customerInfos.findIndex(item => item.name.toLowerCase() === name.toLowerCase()) > -1

  addCustomerInfo = (data, customerInfos) => {
    customerInfos.push(data)
    this.setState({ customerInfos })
    this.saveCustomerInfo(customerInfos)
  }

  removeCustomerInfo = (name, customerInfos) => {
    if (window.confirm(`Do you want to remove "${name}" from customer information?`)) {
      const newData = customerInfos.filter(item => item.name !== name)
      this.setState({ customerInfos: newData })
      this.saveCustomerInfo(newData)
      return true
    }
    return false
  }

  renderEditCustomerInfos = (customerInfos, showCustomerInfo, running, success, error) => {

    customerInfos = customerInfos ? customerInfos : []
    const showIcon = showCustomerInfo ? 'minus' : 'plus',
      title = `${showCustomerInfo ? 'Hide' : 'Display'} customer information`

    return <div>
      <div className="flex-row">
        <h4 className="cursor-pointer font-600" title={ title }
          onClick={_ => this.setState({ showCustomerInfo: ! showCustomerInfo })}>
          [<FontAwesome name={ showIcon } />]
          Customer information
        </h4>
        { this.renderStatuses(running, success, error, () => this.saveCustomerInfo(customerInfos)) }
      </div>

      { showCustomerInfo ?
        <CustomerInfoTable
          customerInfos={ customerInfos }
          removeCustomerInfo={name => this.removeCustomerInfo(name, customerInfos) }
          addInfo={data => this.addCustomerInfo(data, customerInfos) }
          infoExists={name => this.infoExists(name, customerInfos) }
          running={ running }
        /> : null
      }
    </div>
  }

  documentExists = (imageType, customerDocuments) =>
    customerDocuments.findIndex(item => item.imageType.toLowerCase() === imageType.toLowerCase()) > -1

  addCustomerDocument = (data, customerDocuments) => {
    customerDocuments.push(data)
    this.setState({ customerDocuments })
    this.saveCustomerDocuments(customerDocuments)
  }

  removeCustomerDocument = (label, customerDocuments) => {
    if (window.confirm(`Do you want to remove "${label}" from customer documents?`)) {
      const newData = customerDocuments.filter(item => item.label !== label)
      this.setState({ customerDocuments: newData })
      this.saveCustomerDocuments(newData)
      return true
    }
    return false
  }

  renderEditCustomerDocuments = (customerDocuments, showCustomerDocuments, running, success, error) => {

    customerDocuments = customerDocuments ? customerDocuments : []
    const showIcon = showCustomerDocuments ? 'minus' : 'plus',
      title = `${showCustomerDocuments ? 'Hide' : 'Display'} customer documents`

    return <div>
      <div className="flex-row">
        <h4 className="cursor-pointer font-600" title={ title }
          onClick={_ => this.setState({ showCustomerDocuments: !showCustomerDocuments })}>
          [<FontAwesome name={ showIcon } />]
          Customer documents
        </h4>
        { this.renderStatuses(running, success, error, () => this.saveCustomerDocuments(customerDocuments)) }
      </div>

      { showCustomerDocuments ?
        <CustomerDocumentTable
          customerDocuments={ customerDocuments }
          removeCustomerDocument={label => this.removeCustomerDocument(label, customerDocuments) } 
          addDocument={data => this.addCustomerDocument(data, customerDocuments) }
          documentExists={imageType => this.documentExists(imageType, customerDocuments) }
          running={ running }
        /> : null
      }
    </div>
  }

  renderStatuses = (running, success, error, callback) => (
    <div>
      { error ?
      <span className="hot-color">
        { error }{' '}
        <span className="cursor-pointer blue" onClick={ callback }>Click to retry!</span>
      </span>
      : running
        ? <span className="gray">Running ..</span>
        : success
          ? <span className="green">Saved <FontAwesome name="check" /></span>
          : null
      }
    </div>
  )

  render() {

    const { customerInfos, showCustomerInfo, runningInfo, successInfo, errorInfo, customerDocuments,
      showCustomerDocuments, runningDocuments, successDocuments, errorDocuments, error } = this.state

    return (
      <div>
        <CustomBreadCrumb activeText='Customers data' data={ [{ url: '/settings', title: 'Settings' }] } />
        <Row>
          <Col md={8}>

            { error ?
              <p className="hot-color">
                { error }{' '}
                <span className="cursor-pointer blue" onClick={ this.loadData }>Click to retry!</span>
              </p>
              : null
            }

            { this.renderEditCustomerInfos(customerInfos, showCustomerInfo, runningInfo, successInfo, errorInfo) }
            <br />
            { this.renderEditCustomerDocuments(customerDocuments, showCustomerDocuments, runningDocuments, successDocuments, errorDocuments) }
            <br />
          </Col>
        </Row>
      </div>
    )
  }
}

export default CustomerDataSettings



// WEBPACK FOOTER //
// ./src/components/Settings/Customers/index.js